import { Button, SelectDropDown } from '@wot/components';
import React, { SetStateAction, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import usersApi from '../../api/users';
import { BACK_ARROW, DEFAULT_PROFILE_PIC, PLUS_ICON } from '../../assets/icons';
import PhoneNumberInput from '../../components/PhoneNumberInput/PhoneNumberInput';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { setUserProfile } from '../../reducers/userSlice';
import { API_URL } from '../../utils/constants';
import xhr from '../../utils/fetch';
import authApi from '../../api/auth';

interface IloginStep {
  setStep: React.Dispatch<SetStateAction<number>>;
}

const CompleteProfile: React.FC<IloginStep> = ({ setStep }) => {
  const navigate = useNavigate();
  const {
    handleSubmit
    // formState: {
    //   errors
    // }
  } = useForm();
  const { user } = useAppSelector((state) => state.authSlice);
  const { userData } = useAppSelector((state) => state.userSlice);
  const { timezone: t, countryCode, currency } = useAppSelector((state) => state.visitorInfoSlice);
  useEffect(() => {
    if (userData) {
      navigate('/dashboard');
    }
  }, [userData, navigate]);
  const [loading, setLoading] = useState(false);

  const email = user?.email;
  const [timezone, setTimezone] = useState('Asia/Calcutta');
  // @ts-ignore
  const timezones = Intl.supportedValuesOf('timeZone');
  const [uName, setUName] = useState<string>('');
  const [number, setNumber] = useState<string>('');
  const [phoneCount, setPhoneCount] = useState<number | null>(null);
  const [error, setError] = useState(false);
  const [profilePic, setProfilePic] = useState<string>();
  const [selectedImage, setSelectedImage] = useState<File>();
  const profilePicInput = useRef(document.createElement('input'));
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (t) {
      setTimezone(t);
    }
  }, [t]);

  const validate = (user: any) => {
    if (user.phoneNumber.length !== phoneCount) {
      setError(true);
      return false;
    }
    if (!user.email || !user.name || !user.phoneNumber) {
      return false;
    }
    return true;
  };

  const onSubmit = async () => {
    setLoading(true);
    let picUrl = '';
    if (selectedImage) {
      const formData = new FormData();
      formData.append('file', selectedImage);
      picUrl = await fetch(`${API_URL}/upload`, {
        method: 'POST',
        headers:{
              'Access-Control-Allow-Origin':"*"
        },
        body: formData
      })
        .then((res) => res.json())
        .then((res) => res.data);
    }

    setProfilePic(picUrl);
    const user = {
      email: email || '',
      profilePic: picUrl,
      name: uName,
      phoneNumber: number,
      prefrences: {
        lessonUpdates: false,
        accountUpdates: true,
        currency: {
          code: currency.code || 'INR',
          name: currency.name || 'Indian rupee',
          symbol: currency.symbol || '₹'
        },
        timezone: timezone
      },
      status: 'active'
    };
    const isValid = validate(user);
    if (!isValid) {
      setLoading(false);
      return;
    }
    usersApi
      .addUsers(user)
      .then(async (data) => {
        setLoading(false);
        if (data) {
          await xhr({
            url: `/add-user-location`,
            method: 'POST',
            body: {
              userId: data._id,
              role: 'student',
              country: countryCode.toLowerCase()
            }
          })
            .then(() => {
              dispatch(setUserProfile(data));
              navigate('/dashboard');
            })
            .catch((err) => err);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <div className="flex flex-col items-center mt-8">
        <div className="flex lg:flex-row flex-col w-full justify-between lg:gap-0 gap-4">
          <img
            src={BACK_ARROW}
            alt="Go back"
            className="w-5 cursor-pointer"
            onClick={async () => {
              await authApi.logout();
              setStep(0);
            }}
          />
          <h5 className="text-black text-left md:text-center text-2xl md:text-xl font-semibold w-full">
            Complete setting up your profile
          </h5>
        </div>
        <div
          className="h-24 w-24 flex items-center justify-center bg-neutralBlue2 rounded-full mt-4 relative cursor-pointer"
          onClick={() => profilePicInput.current.click()}
        >
          {selectedImage ? (
            <img
              src={URL.createObjectURL(selectedImage)}
              alt="Profile Pic"
              className="h-full w-full object-cover rounded-full"
            />
          ) : profilePic ? (
            <img src={profilePic} alt="Profile Pic" className="h-full w-full object-cover rounded-full" />
          ) : (
            <>
              <img src={DEFAULT_PROFILE_PIC} alt="Profile Pic" className="h-12 w-12 object-cover rounded-full" />
              <img
                src={PLUS_ICON}
                alt="Profile Pic"
                className="h-4 w-4 object-cover rounded-full absolute right-0 left-[90px]"
              />
            </>
          )}
        </div>
        <input
          type="file"
          accept="image/*"
          ref={profilePicInput}
          style={{ display: 'none' }}
          onChange={(e) => {
            // @ts-ignore
            setSelectedImage(e.target.files[0]);
          }}
        />
      </div>
      <div>
        <form onSubmit={(e) => e.preventDefault()} encType="multipart/form-data">
          <div className="flex flex-col mt-3">
            <label htmlFor="Name" className="text-sm font-medium">
              Name
            </label>
            <input
              type="text"
              id="Name"
              placeholder="Name"
              required
              onChange={(e: any) => setUName((e.target as HTMLInputElement).value)}
              className="px-4 py-3 border border-neutralBlue1 rounded-lg"
            />
            {error && <p className="text-xs font-medium text-red-400">{!uName && 'Please Enter Your Name'}</p>}
          </div>

          <div className="flex flex-col mt-4">
            <label htmlFor="Mobile" className="text-sm font-medium">
              Mobile No.
            </label>
            <div className=" w-full flex flex-col">
              <PhoneNumberInput
                value={number}
                containerStyle={{ margin: 0 }}
                setValue={setNumber}
                setPhoneCount={setPhoneCount}
              />
              {error && (
                <p className="text-xs font-medium text-red-400">
                  {phoneCount !== number.length && 'Please Enter Correct Phone Number'}
                </p>
              )}
            </div>
          </div>
          <div className="mt-4">
            <p className="text-sm font-medium">Timezone</p>
            <SelectDropDown
              placeholder="Timezone"
              options={timezones || []}
              value={timezone}
              onChange={(value) => setTimezone(value)}
              isSearchable
            />
          </div>
          <div className="flex flex-col mt-4">
            <label htmlFor="email" className="text-sm font-medium text-neutralGray3">
              Email ID
            </label>
            <input
              type="email"
              id="email"
              placeholder="example@email.com"
              disabled
              value={email}
              className="px-4 py-3 border border-neutralBlue1 rounded-lg text-neutralGray3"
            />
          </div>
          <div className="w-full my-4">
            <Button text="Continue" loading={loading} block onClick={handleSubmit(onSubmit)} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompleteProfile;
